import type {ReactNode} from 'react';
import {Trans} from 'react-i18next';
import {Button, ResponsiveSheet} from '@chekinapp/ui';
import type {Point} from './hintPoints';

type Props = {
  open: boolean;
  onClose: () => void;
  title: string;
  description?: string;
  points: Point[];
  closeLabel?: string;
  children?: ReactNode;
};

function ArrivalHintSheet({
  open,
  onClose,
  title,
  description,
  points,
  closeLabel,
  children,
}: Props) {
  return (
    <ResponsiveSheet
      open={open}
      onClose={onClose}
      title={title}
      description={description}
      dialogClassName="max-w-[440px] sm:max-w-[440px]"
    >
      <div className="flex flex-col gap-3.5">
        {points.map(({icon: Icon, i18nKey}) => (
          <div key={i18nKey} className="flex items-start gap-2.5">
            <span className="mt-px grid size-7 shrink-0 place-items-center rounded-lg bg-[var(--chekin-blue-tint-info)] text-[color:var(--chekin-color-brand-blue)]">
              <Icon size={15} />
            </span>
            <p className="text-[12.5px] leading-[18px] text-[color:var(--chekin-text-secondary)] [&_b]:font-semibold [&_b]:text-[color:var(--chekin-color-brand-navy)]">
              <Trans i18nKey={i18nKey} components={{1: <b />}} />
            </p>
          </div>
        ))}
      </div>

      {(children || closeLabel) && (
        <div className="mt-6 flex flex-col gap-2.5">
          {children}
          {closeLabel && (
            <Button variant="outline" className="w-full" onClick={onClose}>
              {closeLabel}
            </Button>
          )}
        </div>
      )}
    </ResponsiveSheet>
  );
}

export {ArrivalHintSheet};
